import React, { useContext } from 'react';
import ResponsiveSidebar from './ui';

import { CompanyContext } from '../../../context/company-context';

export const Sidebar = () => {
  const { logo } = useContext(CompanyContext);

  // The mobile top bar shows the company logo; the drawer and the desktop rail
  // both render <PortalSidebar/>, which derives user/nav/etc. on its own. The
  // `.wh-mobile-logo` rule in ui.tsx sizes this image with the correct aspect.
  return (
    <ResponsiveSidebar logo={logo ? <img src={logo} alt="" /> : undefined} />
  );
};
